/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  BeginSlackDirectoryConnectionRequestBody,
  BeginSlackDirectoryConnectionRequestBody$Outbound,
  BeginSlackDirectoryConnectionRequestBody$outboundSchema,
} from "../components/beginslackdirectoryconnectionrequestbody.js";

export type BeginSlackDirectoryConnectionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type BeginSlackDirectoryConnectionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  beginSlackDirectoryConnectionRequestBody:
    BeginSlackDirectoryConnectionRequestBody;
};

/** @internal */
export type BeginSlackDirectoryConnectionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const BeginSlackDirectoryConnectionSecurity$outboundSchema:
  z.ZodMiniType<
    BeginSlackDirectoryConnectionSecurity$Outbound,
    BeginSlackDirectoryConnectionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function beginSlackDirectoryConnectionSecurityToJSON(
  beginSlackDirectoryConnectionSecurity: BeginSlackDirectoryConnectionSecurity,
): string {
  return JSON.stringify(
    BeginSlackDirectoryConnectionSecurity$outboundSchema.parse(
      beginSlackDirectoryConnectionSecurity,
    ),
  );
}

/** @internal */
export type BeginSlackDirectoryConnectionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  BeginSlackDirectoryConnectionRequestBody:
    BeginSlackDirectoryConnectionRequestBody$Outbound;
};

/** @internal */
export const BeginSlackDirectoryConnectionRequest$outboundSchema: z.ZodMiniType<
  BeginSlackDirectoryConnectionRequest$Outbound,
  BeginSlackDirectoryConnectionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    beginSlackDirectoryConnectionRequestBody:
      BeginSlackDirectoryConnectionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      beginSlackDirectoryConnectionRequestBody:
        "BeginSlackDirectoryConnectionRequestBody",
    });
  }),
);

export function beginSlackDirectoryConnectionRequestToJSON(
  beginSlackDirectoryConnectionRequest: BeginSlackDirectoryConnectionRequest,
): string {
  return JSON.stringify(
    BeginSlackDirectoryConnectionRequest$outboundSchema.parse(
      beginSlackDirectoryConnectionRequest,
    ),
  );
}
